

















































import { computed, defineComponent } from '@vue/composition-api';
import { InputType, ButtonType } from '@getaccept/lib-ui';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import {
  identifyRecipientProps,
  useIdentifyRecipient,
} from '@getaccept/lib-shared/src/lobby/composables/identify-recipient.composable';

export default defineComponent({
  name: 'IdentifyDsrRecipient',
  props: {
    ...identifyRecipientProps,
  },
  setup(props, { emit }) {
    const {
      documentName,
      email,
      handleClick,
      invalidEmailMessage,
      universalLinkUrl,
      notMatchingEmail,
    } = useIdentifyRecipient(props, emit);

    const handleGotoUniversalLink = () => {
      window.location.replace(universalLinkUrl.value);
    };

    const notMatchingEmailMessage = computed(() =>
      notMatchingEmail.value ? t('no_matching_participant_email_found') : ''
    );

    const notMatchingEmailHelpText = computed(() =>
      universalLinkUrl.value
        ? t(
            'dr_if_you_are_trying_to_use_someone_elses_personal_url_when_universal_link_is_disabled'
          )
        : t('dr_if_you_are_trying_to_use_someone_elses_personal_url_when_universal_link_is_enabled')
    );

    return {
      documentName,
      email,
      handleClick,
      invalidEmailMessage,
      notMatchingEmailMessage,
      notMatchingEmail,
      InputType,
      universalLinkUrl,
      ButtonType,
      handleGotoUniversalLink,
      t,
      notMatchingEmailHelpText,
    };
  },
});
